import Popup from "./components/Popup";

export default () => {
	const videos: HTMLElement[] = Array.from(
		document.querySelectorAll(".has-video")
	);

	if (!videos) return;

	videos.map((videoWrapper: HTMLElement) => Popup(videoWrapper));
};
